import { render, staticRenderFns } from "./JointPunishmentList.vue?vue&type=template&id=0aab7b8e&scoped=true&"
import script from "./JointPunishmentList.vue?vue&type=script&lang=js&"
export * from "./JointPunishmentList.vue?vue&type=script&lang=js&"
import style0 from "./JointPunishmentList.vue?vue&type=style&index=0&id=0aab7b8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab7b8e",
  null
  
)

export default component.exports